import usePageMeta from "@/hooks/usePageMeta";
import { footer } from "@/content/site";

const DOCS = {
  privacy: {
    title: "Privacy policy",
    meta: "How SPC handles personal data submitted through this website.",
    sections: [
      ["What we collect", "When you use a form on this site we collect the details you enter, such as your name, company, role, email, phone, country and the content of your enquiry. We also record basic technical data, such as your IP address and the time of submission, to protect the forms from spam."],
      ["How we use it", "We use your details only to respond to your enquiry and to discuss a potential business relationship. If you choose to continue on WhatsApp, your message is handled under WhatsApp's own terms."],
      ["Sharing", "We do not sell your data. We may share enquiry details with a supplier, licensor, CRO or partner only where needed to answer your request, and only with your agreement where required."],
      ["Retention and your rights", "We keep enquiry details only for as long as we need them to respond to you and to maintain our business records. You can ask to see, correct or delete the details you have shared with us at any time by writing to arjunkhurana@spcindia.net."],
      ["Contact", "For privacy questions, write to arjunkhurana@spcindia.net."],
    ],
  },
  terms: {
    title: "Terms of use",
    meta: "Terms governing the use of the SPC website.",
    sections: [
      ["Audience", footer.disclaimer],
      ["No offer", "Content on this site is general information about SPC's services. It is not an offer to sell or supply any product, and availability depends on regulatory status in each market."],
      ["Intellectual property", "Text, graphics and the SPC mark on this site belong to SPC or its licensors. Third-party names are used for identification only."],
      ["Liability", "This website is provided for general information. To the extent permitted by law, SPC is not liable for any loss arising from the use of this website or from reliance on its content."],
      ["Governing law", "These terms are governed by the laws of Singapore, and the courts of Singapore have jurisdiction over any dispute arising from them."],
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc];
  usePageMeta({ title: `${d.title} | SPC`, description: d.meta });
  return (
    <section className="pb-24 pt-36 sm:pt-44" data-testid={`legal-${doc}`}>
      <div className="container-x max-w-3xl">
        <p className="eyebrow mb-5">Legal</p>
        <h1 className="h-section">{d.title}</h1>
        <div className="mt-12 space-y-10">
          {d.sections.map(([h, body]) => (
            <div key={h} className="border-t border-line pt-6">
              <h2 className="font-display text-2xl font-semibold tracking-[-0.025em] text-ink">{h}</h2>
              <p className="mt-3 text-[15px] leading-relaxed text-muted">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
